import React from 'react'
import { PiWarningBold } from "react-icons/pi"
import useAppContext from '../../hook/useAppContext'
import './warning.css'

const Warning = () => {

      const {user} = useAppContext()
      const {personal, videos} = user 

      if(!personal.code || !videos.code) return 

      return (
            <div className="warning_content">
                  <div className="warning_header flex">
                        <PiWarningBold />
                        <h3>Alert</h3>
                  </div>
                  <div className="warning_text">
                        <p>Configure your data to remove this notice.</p>
                  </div>
            </div>
      )
}

export default Warning
